import React from 'react';
import useStyles from '../styles';
import Divider from '../Divider';
import {
  CustomDatePickerComponent,
  CustomInput,
} from '../../../../../../Components';
import { Calendar } from '@material-ui/pickers';
import { useSelectedTheme } from '../../../../../../Hooks';
import moment from 'moment';
import { CalendarToday } from '@material-ui/icons';

function CPP_BI_PropertySpecificationSection({
  translate,
  selected,
  setSelected,
  handleSelectedChange,
  safeHandleDate,
}) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  return (
    <>
      <div className={styles.CPP_BI_PropertySpecificationSectionWrapper}>
        <div style={{ paddingBottom: '16px' }}>
          <span className={styles.CPP_BI_PropertySpecificationSectionTitle}>
            {translate('property-specification')}
          </span>
        </div>
        <Divider />

        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('number-of-floors')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <CustomInput
              placeholder={translate('enter')}
              hasSearchIcon={false}
              type='number'
              style={{ minWidth: '100%' }}
              value={selected.numberOfFloors}
              onChange={(e) => {
                const value = +e.target.value || null;
                handleSelectedChange('numberOfFloors', value);
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('completion-date')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <CustomDatePickerComponent
              idRef='activityDateRef'
              translate={translate}
              value={selected.completionDate}
              placeholder='dd/mm/yyyy'
              withIcon
              isSubmitted={false}
              onDateChanged={(newValue) => {
                handleSelectedChange('completionDate', newValue);
              }}
              startAdornment={
                <CalendarToday
                  style={{
                    width: 20,
                    height: 20,
                    color: palette.foreground.quarterary,
                  }}
                />
              }
              autoOk={translate('confirm')}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('number-of-residential-units')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <CustomInput
              placeholder={translate('enter')}
              hasSearchIcon={false}
              style={{ minWidth: '100%' }}
              value={selected.numberOfResidentialUnits}
              type='number'
              onChange={(e) => {
                const value = +e.target.value || null;
                handleSelectedChange('numberOfResidentialUnits', value);
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={styles.CPP_itemWrapper}>
          <span className={styles.CPP_fieldLabel}>
            {translate('number-of-commercial-units')}
          </span>
          <div className={styles.CPP_fieldWrapper}>
            <CustomInput
              placeholder={translate('enter')}
              hasSearchIcon={false}
              style={{ minWidth: '100%' }}
              type='number'
              value={selected.numberOfCommercialUnits}
              onChange={(e) => {
                const value = +e.target.value || null;
                handleSelectedChange('numberOfCommercialUnits', value);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default CPP_BI_PropertySpecificationSection;
